import { icon, layer, parse, findIconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faTimesCircle } from '@fortawesome/pro-regular-svg-icons';

const getIcon = (prefix, iconName) => {
	const definition = findIconDefinition({ prefix: prefix, iconName: iconName })
	return icon( definition ).html[0];
}

const getLayeredIcon = (prefixes, iconNames, classes, transforms) => {
	const result = layer((push) => {
		for( var i = 0; i < iconNames.length; i++ ) {
			const prefix = prefixes[i];
			const iconName = iconNames[i];
			const className = classes[i];
            const transform = parse.transform(transforms[i]);

			let definition = findIconDefinition({ prefix: prefix, iconName: iconName });
            
            if( !definition ) {
            	console.error("Icon with prefix %s and name %s cannot be found", prefix, iconName);
            	definition = faTimesCircle;
            }
            
            push(icon(definition, {
            	transform: transform,
            	 classes: [className]
            }));
        }    
    });
        
   	const html = result.html;
   	return html[0];
}

export {
	getIcon,
	getLayeredIcon
}
